/**
 * @param {HTMLElement} field
 * @param {FieldState} fieldState
 */
export function fieldErrors(field, fieldState) {
  const { touched, error, submitError, dirtySinceLastSubmit } = fieldState;

  const fieldBlock = field.closest('.bfe__field');
  const errorTextElement = document.querySelector(`.bfe__field-error[for="${field.id}"]`);

  if (touched && (error || submitError)) {
    fieldBlock.classList.add('error');

    if (field.type !== 'checkbox' && submitError) {
      if (dirtySinceLastSubmit) {
        errorTextElement.innerText = '';
        fieldBlock.classList.remove('error');
      } else {
        errorTextElement.innerText = submitError;
      }
    }

    if (field.type !== 'checkbox' && error) {
      errorTextElement.innerText = error;
    }
  } else {
    if (errorTextElement) {
      errorTextElement.innerText = '';
    }

    if (fieldBlock) fieldBlock.classList.remove('error');
  }
}
